import { useCallback } from 'react';
import { useAxios } from 'api/axios';
import { TaxRate, TaxRatesParams } from './taxRates.types';

export const useGetTaxRates = () => {
  const [{ data, loading }, getTaxRatesReq] = useAxios<{
    result: { data: TaxRate[]; count: number };
  }>({
    method: 'GET',
  });

  const getTaxRates = useCallback(
    ({ filterText = '', pageNumber, resultSize }: TaxRatesParams) => getTaxRatesReq({
        url: `/taxrate`,
        params: { filterText, pageNumber, resultSize },
      }),
    [getTaxRatesReq],
  );

  return {
    data: data?.result?.data,
    loading,
    getTaxRates,
  };
};

export const useGetDefaultTaxRate = () => {
  const [{ data, loading }, getDefaultTaxRateReq] = useAxios<{
    result: TaxRate;
  }>({
    method: 'GET',
  });

  const getDefaultTaxRate = useCallback(() => getDefaultTaxRateReq({
      url: `/taxrate/default`,
    }), [getDefaultTaxRateReq]);

  return {
    data: data?.result,
    loading,
    getDefaultTaxRate,
  };
};
